
import { Language } from "@edp-models/language.model";
import { Action } from "@ngrx/store";

export enum ELanguageActions {
    GetLanguages = "Get languages",
    SetLanguages = "Set languages",
}

export class GetLanguages implements Action {
    public readonly type = ELanguageActions.GetLanguages;
}

export class SetLanguages implements Action {
    public readonly type = ELanguageActions.SetLanguages;
    constructor(public languages: Language[]) { }
}

export type LanguageActions = GetLanguages | SetLanguages;

